var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_895_17800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14466 20.4406C6.11849 20.5789 5.1646 19.8894 4.97969 18.8758L4.75226 17.6292C4.68709 17.2719 4.46193 16.9636 4.14051 16.7915L3.01901 16.1911C2.10712 15.703 1.74276 14.5874 2.19206 13.6592L2.74463 12.5177C2.90299 12.1905 2.90299 11.8095 2.74463 11.4823L2.19206 10.3408C1.74276 9.41262 2.10712 8.29706 3.01901 7.80888L4.14051 7.20848C4.46193 7.03641 4.68709 6.7281 4.75226 6.37083L4.97969 5.1242C5.1646 4.11058 6.11849 3.42112 7.14466 3.5594L8.40672 3.72945C8.76842 3.77819 9.13274 3.66043 9.39656 3.4095L10.3171 2.53394C11.0656 1.82203 12.2447 1.82203 12.9932 2.53394L13.9137 3.4095C14.1775 3.66043 14.5419 3.77819 14.9036 3.72945L16.1656 3.5594C17.1918 3.42112 18.1457 4.11058 18.3306 5.1242L18.3517 5.24012C18.5473 6.31193 19.2228 7.23684 20.187 7.75305L20.2913 7.80888C21.2032 8.29706 21.5675 9.41262 21.1182 10.3408L20.5656 11.4823C20.4073 11.8095 20.4073 12.1905 20.5656 12.5177L21.1182 13.6592C21.5675 14.5874 21.2032 15.703 20.2913 16.1911L19.1698 16.7915C18.8484 16.9636 18.6232 17.2719 18.558 17.6292L18.3306 18.8758C18.1457 19.8894 17.1918 20.5789 16.1656 20.4406L14.9036 20.2706C14.5419 20.2218 14.1775 20.3396 13.9137 20.5905L12.9932 21.4661C12.2447 22.178 11.0656 22.178 10.3171 21.4661L9.39656 20.5905C9.13274 20.3396 8.76842 20.2218 8.40672 20.2706L7.14466 20.4406Z",
    fill: "url(#paint0_linear_895_17800)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16V12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H12.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_895_17800",
    x: 1.99994,
    y: 2,
    width: 19.3104,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_895_17800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_895_17800",
    x1: 2,
    y1: 4.08333,
    x2: 19.0833,
    y2: 19.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C48FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuz);
export default __webpack_public_path__ + "static/media/buz.6f3f791809e572affddf5a4e1e81890a.svg";
export { ForwardRef as ReactComponent };